export default __webpack_public_path__ + "6ad3cb0b2330876b3c6be006ee4ed3ea.jpg";